import { forwardRef } from 'react'
import {
  Box,
  Button,
  ButtonProps,
  LinearProgress,
  Tooltip,
} from '@mui/material'

interface SubmitButtonProps extends ButtonProps {
  label?: string
  loading?: boolean
  type?: 'submit' | 'button'
}

const SubmitButton = forwardRef<HTMLButtonElement, SubmitButtonProps>(
  (props, ref) => {
    const {
      children,
      label,
      loading = false,
      title,
      type = 'submit',
      ...rest
    } = props
    const button = (
      <Button
        {...rest}
        disabled={rest.disabled || loading}
        ref={ref}
        sx={{
          ...(rest.sx ?? {}),
          position: 'relative',
          overflow: 'clip',
        }}
        type={type}
      >
        {loading && (
          <Box
            component="span"
            sx={{ position: 'absolute', left: 0, right: 0, bottom: 0 }}
          >
            <LinearProgress sx={{ height: '2px' }} />
          </Box>
        )}
        <Box component="span" sx={{ position: 'relative' }}>
          {children ?? label}
        </Box>
      </Button>
    )
    return title ? <Tooltip title={title}>{button}</Tooltip> : button
  }
)

SubmitButton.displayName = 'SubmitButton'

export default SubmitButton
